<dx-popup
    #serviceChargeEditor
    minWidth="150px"
    minHeight="100px"
    width="60%"
    height="55%"
    [title]="popUpTitle"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col" class="service-charge-editor-box">
            <dxi-item [ratio]="1">
                <dx-form
                    #serviceChargeForm
                    class="service-charge-editor-form"
                    width="100%"
                    height="100%"
                    validationGroup="apserviceChargeEditor"
                    [colCount]="2"
                    [showValidationSummary]="true"
                    [labelLocation]="defaultLabelLocation"
                >
                    <dxi-item [isRequired]="true" [colSpan]="2">
                        <dxo-label text="Service Charge Amount"></dxo-label>
                        <div *dxTemplate>
                            <dx-number-box
                                [width]="100"
                                [format]="currencyFormat"
                                [(value)]="serviceCharge.amount"
                            ></dx-number-box>
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="2">
                        <dxo-label text="Description"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-box [(value)]="serviceCharge.description"></dx-text-box>
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="2">
                        <div *dxTemplate class="service-charge-radio-group">
                            <dx-radio-group
                                layout="horizontal"
                                [items]="radioItems"
                                [(value)]="selectedRadioItem"
                                (onValueChanged)="onServiceChargeRadioClick()"
                            ></dx-radio-group>
                        </div>
                    </dxi-item>
                    <dxi-item [isRequired]="true" *ngIf="selectedRadioItem !== accountLabelText">
                        <dxo-label text="GL Account"></dxo-label>
                        <div *dxTemplate>
                            <app-multi-column-selector
                                #glAccountSelector
                                [name]="'GL Accounts'"
                                [gridSource]="glAccounts"
                                [boxValue]="glAccountGridBoxValue"
                                [dropDownButtonTemplate]="'dropDownButton'"
                                [dropDownOptions]="{ width: 450 }"
                                [valueExpr]="'glAccountNumber'"
                                [displayExpr]="'displayText'"
                                [columnDef]="glAccountColumns"
                                [showClearButton]="true"
                                [placeholder]="'Select GL Accounts...'"
                                (gridSelectionEvent)="onGLAccountSelection($event.selectedRow)"
                            ></app-multi-column-selector>
                        </div>
                    </dxi-item>
                    <dxi-item [isRequired]="true" *ngIf="selectedRadioItem !== accountLabelText">
                        <dxo-label text="Offset GL Account"></dxo-label>
                        <div *dxTemplate>
                            <app-multi-column-selector
                                #offsetGLAccountSelector
                                [name]="'Offset GL Accounts'"
                                [gridSource]="glAccountLabels"
                                [boxValue]="offSetGLAccountGridBoxValue"
                                [dropDownButtonTemplate]="'dropDownButton'"
                                [dropDownOptions]="{ width: 500 }"
                                [valueExpr]="'offsetGLAccountNumber'"
                                [displayExpr]="'displayText'"
                                [columnDef]="offSetGLAccountColumns"
                                [showClearButton]="true"
                                [placeholder]="'Select Offset GL Accounts...'"
                                (gridSelectionEvent)="onOffsetGLAccountSelection($event.selectedRow)"
                            ></app-multi-column-selector>
                        </div>
                    </dxi-item>

                    <dxi-item [isRequired]="true" *ngIf="selectedRadioItem === accountLabelText">
                        <dxo-label text="Account Label"></dxo-label>
                        <div *dxTemplate>
                            <app-multi-column-selector
                                #accountLabelSelector
                                [name]="'Account Label'"
                                [gridSource]="glAccountLabels"
                                [boxValue]="accountLabelGridBoxValue"
                                [dropDownButtonTemplate]="'dropDownButton'"
                                [dropDownOptions]="{ width: 500 }"
                                [valueExpr]="'code'"
                                [displayExpr]="'labelDisplayText'"
                                [columnDef]="accountLabelColumns"
                                [showClearButton]="true"
                                [placeholder]="'Select Account Label...'"
                                (gridSelectionEvent)="onAccountLabelSelection($event.selectedRow)"
                            ></app-multi-column-selector>
                        </div>
                    </dxi-item>

                    <dxi-item *ngIf="entityUsesSubCategory">
                        <dxo-label text="Sub Category"></dxo-label>
                        <div *dxTemplate>
                            <dx-select-box
                                displayExpr="title"
                                valueExpr="code"
                                [disabled]="isSubCategoryDisabled"
                                [dataSource]="subCategories"
                                [(value)]="serviceCharge.subCategoryCode"
                            ></dx-select-box>
                        </div>
                    </dxi-item>
                    <dxi-item itemType="empty"></dxi-item>

                    <dxi-item [isRequired]="dim.required" *ngFor="let dim of glDimensions">
                        <dxo-label [text]="dim.text"></dxo-label>
                        <div *dxTemplate>
                            <dx-select-box
                                [showClearButton]="true"
                                [searchEnabled]="true"
                                [dataSource]="dim.options"
                                [(value)]="dim.selectedDimension"
                                displayExpr="text"
                                valueExpr="code"
                                (onValueChanged)="onDimChangeClick($event, dim)"
                            ></dx-select-box>
                        </div>
                    </dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item baseSize="auto">
                <dx-toolbar width="100%">
                    <dxi-item location="after" [visible]="serviceChargeEditorData.allowAddPayCharge">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                useSubmitBehavior="true"
                                [icon]="plusIcon"
                                text="Add and Pay Service Charge"
                                (onClick)="onAddPayAndSChargeClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>

                    <dxi-item location="after" [visible]="serviceChargeEditorData.allowAddPayBill">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                useSubmitBehavior="true"
                                [icon]="plusIcon"
                                text="Add Service Charge and Pay Including Bill"
                                (onClick)="onAddSChargeAndPayIncludingBillClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
